// import logo from './logo.svg';
import "./App.css";
import React from "react";
import { Route, Routes } from "react-router-dom";
import LandingPage from "./Components/LandingPage";
import VideoPageView from "./Components/VideoPageView";


export const config={endpoint:"https://dcecb8d3-0940-4c35-ad07-04a6663778a3.mock.pstmn.io/v1",}

function App() {
  return (
    <div className="App">
    <React.StrictMode>
       <Routes>
            <Route exact path ="/" element={<LandingPage/>} />
            <Route path="/videos/:id" element={<VideoPageView/>} /> 
      </Routes>
    </React.StrictMode>
    </div>
  );
}

export default App;
